import DefaultElementNodeType from '../DefaultElementNodeType';
import {STRATEGY_VALUE_STREAM} from '../../metamodel/Concept';

export default class ValueStreamNodeType extends DefaultElementNodeType {
	static get typeName() {
		return STRATEGY_VALUE_STREAM;
	}
}
